import { Capacitor } from '@capacitor/core'
import { StatusBar, Style } from '@capacitor/status-bar'

/**
 * Sit beneath the Android status bar rather than behind it. The durable
 * setting is the StatusBar block in capacitor.config.json, read when the
 * activity starts; this call makes an install that predates it behave the
 * same on its next launch.
 *
 * Deliberately not an async function returning the plugin: a Capacitor
 * plugin proxy is a thenable by accident and a promise adopting it never
 * settles (see useBarcodeScanner). Only the method calls are awaited.
 */
export function placeBeneathStatusBar(): void {
  if (!Capacitor.isNativePlatform()) return
  void Promise.allSettled([
    StatusBar.setOverlaysWebView({ overlay: false }),
    StatusBar.setStyle({ style: Style.Light }),
    StatusBar.setBackgroundColor({ color: '#FAFAF7' }),
  ]).then((results) => {
    const failed = results.find((r) => r.status === 'rejected')
    if (failed && failed.status === 'rejected') {
      // iOS has no background colour or overlay setter; that is not an error worth a sentence.
      console.warn('[status-bar]', (failed.reason as Error)?.message ?? failed.reason)
    }
  })
}
